import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import ArtworkDetail from "./pages/ArtworkDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import PaymentSuccess from "./pages/PaymentSuccess";
import About from "./pages/About";
import Artists from "./pages/Artists";
import ArtistDetail from "./pages/ArtistDetail";
import FamousArtists from "./pages/FamousArtists";
import Auctions from "./pages/Auctions";
import AuctionSuccess from "./pages/AuctionSuccess";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Account from "./pages/Account";
import Messages from "./pages/Messages";
import Information from "./pages/Information";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

function Layout({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <div className="grain">
      {!isAdmin && <Navbar />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Toaster position="top-center" theme="dark" richColors />
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/galerie" element={<Gallery />} />
                <Route path="/oeuvre/:id" element={<ArtworkDetail />} />
                <Route path="/panier" element={<Cart />} />
                <Route path="/paiement" element={<Checkout />} />
                <Route path="/paiement/succes" element={<PaymentSuccess />} />
                <Route path="/a-propos" element={<About />} />
                <Route path="/artistes" element={<Artists />} />
                <Route path="/artiste/:slug" element={<ArtistDetail />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/artistes-celebres" element={<FamousArtists />} />
                <Route path="/encheres" element={<Auctions />} />
                <Route path="/encheres/succes" element={<AuctionSuccess />} />
                <Route path="/connexion" element={<Login />} />
                <Route path="/inscription" element={<Register />} />
                <Route path="/compte" element={<Account />} />
                <Route path="/messagerie" element={<Messages />} />
                <Route path="/informations" element={<Information />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </Layout>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
